import { atom } from 'recoil';

export const tankMenuIdAtom = atom({
  key: 'tankMenuIdAtom',
  default: localStorage.getItem('tankMenuId') ?? 0,
});
